import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Section } from '../../data/sections';
import { SubsectionAccordion } from './SubsectionAccordion';
interface SectionPageProps {
  section: Section;
  prevSection?: Section | null;
  nextSection?: Section | null;
}
export function SectionPage({
  section,
  prevSection,
  nextSection
}: SectionPageProps) {
  const Icon = section.icon;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="mx-auto max-w-4xl pb-24" data-id="element-194" data-mp="1w8sdfdp1qaih">
      <div className="mb-10" data-id="element-195" data-mp="1mk0olefa86bs">
        <div className="mb-4 flex items-center gap-3 text-primary" data-id="element-196" data-mp="1mh4slvmzvrpz">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10" data-id="element-197" data-mp="18kr7mcj9586r">
            <Icon className="h-5 w-5" data-id="element-198" data-mp="1cjrp9rpzu4s6" />
          </div>
          <span className="font-semibold tracking-wider text-sm uppercase" data-id="element-199" data-mp="c8w1zar9met3">
            Section {section.number}
          </span>
        </div>
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl mb-4" data-id="element-200" data-mp="78ztay7mhz77">
          {section.title}
        </h1>
        <p className="text-xl text-muted-foreground leading-relaxed" data-id="element-201" data-mp="m4zacycpn9oh">
          {section.summary}
        </p>
      </div>

      <div className="space-y-6" data-id="element-202" data-mp="3pnsbucs7s82a">
        {section.subsections.map(subsection => <SubsectionAccordion key={subsection.id} subsection={subsection} defaultOpen={false} data-id="element-203" data-mp="3plfsbv6t5pn4" />)}
      </div>

      {/* Section navigation */}
      {(prevSection || nextSection) && <div className="mt-16 pt-8 border-t" data-id="element-204" data-mp="3umls2cyvyd65">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-205" data-mp="3uksh4lh8p6sc">
            {/* Previous Section */}
            {prevSection ? <Link to={`/section/${prevSection.id}`} className="group flex flex-col items-start gap-1 rounded-xl border bg-card p-5 shadow-sm transition-all hover:border-primary/40 hover:shadow-md" data-id="element-206" data-mp="31ypu74xkyf7s">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground" data-id="element-207" data-mp="3vm43v8eo7vhn">
                  <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-1" data-id="element-208" data-mp="982uoxuc64v8" />
                  Previous · Section{' '}
                  {String(prevSection.number).padStart(2, '0')}
                </span>
                <span className="text-base font-semibold text-foreground group-hover:text-primary transition-colors" data-id="element-209" data-mp="3cq495pub6dud">
                  {prevSection.title}
                </span>
              </Link> : <div data-id="element-210" data-mp="3mots7lxxy4c7" />}

            {/* Next Section */}
            {nextSection ? <Link to={`/section/${nextSection.id}`} className="group flex flex-col items-end gap-1 rounded-xl border bg-card p-5 shadow-sm transition-all hover:border-primary/40 hover:shadow-md text-right md:col-start-2" data-id="element-211" data-mp="wxf15pya3ytu">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground" data-id="element-212" data-mp="2hfpidd07resw">
                  Next · Section {String(nextSection.number).padStart(2, '0')}
                  <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" data-id="element-213" data-mp="27pef7soct9n2" />
                </span>
                <span className="text-base font-semibold text-foreground group-hover:text-primary transition-colors" data-id="element-214" data-mp="23pvw92g3f8mv">
                  {nextSection.title}
                </span>
              </Link> : null}
          </div>
        </div>}
    </motion.div>;
}